/**
 * Check if developer tools should be enabled.
 * Dev tools are only available in development and staging environments.
 *
 * Reads `window.env` directly rather than going through `getEnv()`: this runs on
 * every `useFlag` render, so it must neither throw nor validate the full schema.
 */
export const isDevToolsEnabled = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  if (window.location.hostname === 'localhost') {
    return true;
  }

  const env = window.env;

  return Boolean(env?.apiBaseUrl?.endsWith('.dev') || env?.namespace?.includes('stage'));
};
